export enum STATUS  {
    NOT_STARTED = 'NOT STARTED',
    PENDING = 'PENDING',
    SUCESS = 'SUCESS',
    FAILED = 'FAILED'
}